import {Button, Form, Modal} from "react-bootstrap";
import InputField from "../../components/InputField";
import {useEffect, useMemo, useRef, useState} from "react";
import useTranslation from "../../hooks/translations";
import SelectField from "../../components/SelectField";
import {useApi} from "../../contexts/ApiProvider";
import CostTypeService from "../../services/CostTypeService";
import CostCategoryService from "../../services/CostCategoryService";

export default function CostCategoryModal({
                                            showModal,
                                            title,
                                            data,
                                            onModalSubmit,
                                            onModalClose
                                          }) {
  const nameField = useRef();
  const descriptionField = useRef();
  const typeField = useRef();
  const [formErrors, setFormErrors] = useState({});
  const translations = useTranslation();
  const api = useApi()
  const costTypeService = useMemo(() => new CostTypeService(api), [api]);
  const costCategoryService = useMemo(() => new CostCategoryService(api), [api]);
  const [costTypeOptions, setCostTypeOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");

  useEffect(() => {
    const getCostTypes = async () => {
      const response = await costTypeService.getAll();
      const typeOptions = response.body.map((item) => {
        return {value: item.id, name: item.name};
      });
      setCostTypeOptions(typeOptions);
    }
    (async () => {
      await getCostTypes()
      if (Object.keys(data).length > 0) {
        nameField.current.value = data.name;
        descriptionField.current.value = data.description;
        setSelectedOption(data.typeId);
      } else {
        nameField.current.focus();
      }
    })();
  }, [data]);

  // select field change event
  const handleChange = (option) => {
    setSelectedOption(option.currentTarget.value);
  };

  const handleClose = () => {
    onModalClose()
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    const name = nameField.current.value;
    const description = descriptionField.current.value;
    const selectedType = parseInt(typeField.current.value);

    const errors = {};
    if (!name) {
      errors.name = translations.errorName;
    }
    if (!selectedType) {
      errors.type = translations.errorType;
    }
    setFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      return;
    }

    const submitData = {
      name,
      description,
      type_id: selectedType
    }

    if (data.id) {
      const response = await costCategoryService.put(data.id, submitData);
      if (!response.ok) {
        return
      }
    } else {
      const response = await costCategoryService.create(submitData);
      if (!response.ok) {
        return
      }
    }

    onModalSubmit(submitData)
  }

  return (
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title ? title : translations.costCategory}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={onSubmit} id="costCategoryForm">
          <div className="mb-3">
            <div className="mb-3">
              <InputField
                name="inputName"
                label={translations.name}
                placeholder={translations.enterName}
                error={formErrors.name}
                fieldRef={nameField}
              />
            </div>
            <SelectField
              name="costCategoryType"
              label={translations.type}
              placeholder={translations.enterType}
              options={costTypeOptions}
              selectedOption={selectedOption}
              handleChange={handleChange}
              error={formErrors.type}
              fieldRef={typeField}
            />
          </div>
          <div className="mb-3">
            <InputField
              name="inputDescription"
              label={translations.description}
              placeholder={translations.enterDescription}
              error={formErrors.description}
              fieldRef={descriptionField}
              asTextarea={true}
            />
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" type="submit"
                form="costCategoryForm">{translations.save}</Button>
        <Button variant="secondary"
                onClick={handleClose}>{translations.close}</Button>
      </Modal.Footer>
    </Modal>
  )
}
